import type { FC } from 'react';

import { priceRecipe } from './Price.css';
import { extractDataProps } from '../../util/attributes';
import { Stack } from '../Stack/Stack';
import { Strikethrough } from '../Strikethrough/Strikethrough';
import { Text } from '../Text/Text';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden';

export interface PriceProps {
  discountPrice: string;
  discountPriceAriaText: string;
  originalPrice: string;
  originalPriceAriaText: string;
  text?: string;
  suffixText?: string;
  size?: 'M' | 'S';
}

const sparkyPriceClassName = 'sparky-price';

export const Price: FC<PriceProps> = ({
  discountPrice,
  discountPriceAriaText,
  originalPrice,
  originalPriceAriaText,
  text,
  suffixText,
  size = 'M',
  ...rest
}) => {
  const dataSet = extractDataProps(rest);

  const textSize = size === 'M' ? 'BodyL' : 'BodyM';

  return (
    <div {...dataSet} className={sparkyPriceClassName} data-testid="price-container">
      <Stack>
        <Stack direction="row" alignY="end" gap="1">
          <Text as="p" className={priceRecipe({ size })}>
            <VisuallyHidden>{discountPriceAriaText}</VisuallyHidden>
            {discountPrice}
          </Text>
          <Text as="p" color="textLowEmphasis">
            <Strikethrough semanticDescription={originalPriceAriaText}>{originalPrice}</Strikethrough>
          </Text>
          {suffixText && (
            <Text as="p" color="textLowEmphasis">
              {suffixText}
            </Text>
          )}
        </Stack>
        {text && (
          <Text as="p" size={textSize}>
            {text}
          </Text>
        )}
      </Stack>
    </div>
  );
};

Price.toString = () => `.${sparkyPriceClassName}`;

export default Price;
